import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import {useMediaQuery} from '@s-ui/react-hooks'
import MoleculeBadgeCounter, {moleculeBadgeCounterSizes} from '@s-ui/react-molecule-badge-counter'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'
import IconChevronRight from '@adv-mt/mt-svg-icons/lib/ChevronRight'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS = 'mt-ComparatorButton'

const ComparatorButton = ({comparatorSelectedAds = [], isOpen = false, onToggle, origin}) => {
  const {domain, i18n} = useSuiContext()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {
    HIT_ORIGINS: {LIST},
    TRACKING_EVENT_NAMES: {AD_TO_COMPARE_MENU_CLICKED}
  } = config.get('tracking')
  const isMobile = config.get('isMobile')
  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !isMobile
  })

  const onClick = async e => {
    e.preventDefault()
    e.stopPropagation()

    if (!isOpen) {
      await trackOpeningComparatorModal()
    }
    onToggle?.(!isOpen)
  }

  const trackOpeningComparatorModal = async () => {
    const adComparatorTrackingData = await domain.get('get_event_tracking_data_use_case').execute({
      event: AD_TO_COMPARE_MENU_CLICKED,
      origin: origin || LIST,
      ads: comparatorSelectedAds
    })
    track(adComparatorTrackingData)
  }

  return (
    <div className={BASE_CLASS}>
      <AtomButton
        shape={atomButtonShapes.CIRCULAR}
        size={atomButtonSizes.LARGE}
        onClick={onClick}
        rightIcon={isHigherThanMobile ? <IconChevronRight /> : <IconChevronDown />}
        leftIcon={
          <MoleculeBadgeCounter
            label={comparatorSelectedAds?.length}
            size={moleculeBadgeCounterSizes.LARGE}
            className={`${BASE_CLASS}-badgeCounter`}
          />
        }
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-controls="comparator-modal"
      >
        {i18n.t('COMPARATOR.ADS_LIST_CTA_BUTTON')}
      </AtomButton>
    </div>
  )
}

ComparatorButton.displayName = 'ComparatorButton'

ComparatorButton.propTypes = {
  comparatorSelectedAds: PropTypes.array,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  origin: PropTypes.string
}

export default ComparatorButton
